import actionTypes from './action-types';
import attributes from './attributes';

export default {
  actionTypes,
  attributes,
};
